import { InstanceUrlMapStateData } from 'src/types/state/learningModule';

/**
 * Defines the default preferred order for video source types in learning modules.
 * This array specifies the default priority sequence when multiple video sources are available
 * for a learning module instance.
 *
 * Currently, Media Central (which points to our CDN) is the default
 * since this video source isn't limited by firewalls.
 *
 * @type {(keyof InstanceUrlMapStateData)[]}
 *
 * @example
 * // Using the preference order to find the first available video source
 * const availableSource = videoSourcePreference
 *   .find(source => instance.urlMap[source]);
 *
 * @see InstanceUrlMapStateData - Interface defining all possible URL types
 *                               including PDF, MEDIA_CENTRAL, and YOUTUBE
 */
export const DEFAULT_VIDEO_SRC_PREFERENCE: (keyof InstanceUrlMapStateData)[] = ['MEDIA_CENTRAL', 'YOUTUBE'];
